
import util from '@/mixins/util';

export default {
  mixins: [],
  data() {
    return {
      ApiData : [],
     Categorys : [],
      List : [],
      pageRow: 10,
      apiListLength: 0,
      page: 1,
      tableLoading: true,
      sort: null,
      order: null,
      searchFilter : [],
      searchModelObj: [],
      searchValue : [{
        modelname: '',
        name: '',
        func: null,
        value: '',
        type: ''
      }],
      filterData : [],
      filterFlag : false,
      oriApiData: [],
      tableSorting: {},
      choiceRow : [],
      deleteValue : [{
          name: '',
          value: '',
      }],
      ListSortValue: {
        name: '',
        value: ''
      },
      childTab : 1,
      pageRows: [10, 20, 30],
      apiPage: {
        "total": 0,
        "per_page": this.pageRow,
        "current_page": this.page,
        "last_page": 0
      },
    }
  },
  methods: {
    getTotalSearchValue() {
      return {
        searchValue : this.searchValue,
        page: this.page,
        pageRow: this.pageRow,
        ListSortValue: this.ListSortValue,
        childTab : this.childTab
      };
    },
      getTotalChildSearchValue(orgData) {
        return {
            searchValue : orgData.searchValue,
            page: orgData.page,
            pageRow: orgData.pageRow,
            ListSortValue: orgData.ListSortValue,
            childPage: this.page,
            childPageRow: this.pageRow
        };
    },
    getSearchValue(index) {
      return this.searchValue[index].value;
    },
    setPageRow(row) {
          this.pageRow = row;
      },
      setPage(page) {
          this.page = page;
      },
     setChildTab(childTab) {
      this.childTab = childTab;
     },
    FilterDelete(name) {
      let index = $.inArray(name, this.searchFilter);
      if(index > 0) {
        this.searchValue.splice(index, 1);
        this.searchFilter.splice(index, 1);
      }
    },
    FilterReset() {
      this.searchFilter =[],
      this.searchValue = [{
        name: '',
        func: null,
        value: '',
        type: ''
      }];
    },
    startSetFilter(searchFilter, searchValue) {
      this.searchFilter =searchFilter,
      this.searchValue = searchValue.searchValue;
    },
    startSearch() {
      //카테고리 필터
      if(this.searchValue[0].name =='') {
        this.filterFlag = false;
        return;
      }

      this.filterData =  this.ApiData;
      this.filterFlag = true;
      for(let i = 0 ; i < this.searchFilter.length ; i ++) {
        if(this.searchValue[i].func !== null) {
          this.filterData = this.filterData.filter(data => !this.searchValue[i].value || this.searchValue[i].func(data))
        } else if(this.searchValue[i].type == "string") {
          this.filterData = this.filterData.filter(data => !this.searchValue[i].value || (this.$_.result(data, this.searchValue[i].name) && this.$_.result(data, this.searchValue[i].name).includes(this.searchValue[i].value)))
        } else {
          this.filterData = this.filterData.filter(data => this.searchValue[i].value === "" || Number(this.$_.result(data, this.searchValue[i].name)) === Number(this.searchValue[i].value))
        }
      }

    },
    //modelname 다수일경우 | 기준으로 1번째 value, 2번째 name,
    setFilter(modelname, name, value, type ='string', func = null) {
      let index = $.inArray(modelname, this.searchFilter);
      if(index > -1) {
         this.searchValue[index].modelname = modelname;
         this.searchValue[index].name = name;
         this.searchValue[index].value = value;
         this.searchValue[index].type = type;
         this.searchValue[index].func = func;
      } else {
        let index = this.searchFilter.length;
        this.searchFilter[index] = modelname;
        this.searchValue[index] = {};
        this.searchValue[index].modelname = modelname;
        this.searchValue[index].name = name;
        this.searchValue[index].type = type;
        this.searchValue[index].value = value;
        this.searchValue[index].func = func;
      }
      this.startSearch();
    },
    setSort(name, value) {
      if(name && value) {
        this.ListSortValue.name = name;
        this.ListSortValue.value = value;
        if(this.filterFlag) {
          this.filterData = this.$_.orderBy(this.filterData, name, value);
        } else {
          this.ApiData = this.$_.orderBy(this.ApiData, name, value);
        }
      }else{
        this.ListSortValue.name = null;
        this.ListSortValue.value = null;
        if(this.filterFlag) {
          this.ApiData = this.oriApiData.slice(0)
          this.startSearch();
        } else {
          this.ApiData = this.oriApiData.slice(0)
        }
      }
    },
    setAlFilter(query) {
      if(query != "") {
        this.filterFlag = true;
        this.SetAlQuery(query);
        this.filterData = this.SearchAlQuery();
      }
    },
    setAlSort(sortName, sortValue) {
      if(sortName != "" && sortValue != "") {
        this.filterFlag = true;
        this.filterData = this.SortAlQuery(sortName, sortValue);
      }
    },
    getApiResult(func,boardKey) {
      this.tableLoading = true;
      func.then(data => {
          if(data.Data.Result.Info.status) {
            this.ApiData = data.Data.Result.List;
            let keyName = boardKey ? boardKey : '';
            if(keyName){
                this.ApiData.forEach((data, index) => {
                    let cateWrap = this.Categorys.filter(cate => cate[keyName] == data[keyName])
                    data.category_name = cateWrap.length > 0 ? cateWrap[0].bc_name : data.bc_idx;
                })
            }
            if(data.Data.Result.hasOwnProperty('Page')) {
                this.apiPage = data.Data.Result.Page;
            }
          }
          this.tableLoading = false;
      });
    },

    getStatusApiResult(func,obj) {
          this.tableLoading = true;
          func.then(data => {
              if(data.Data.Result.Info.status) {
                  this.ApiData = data.Data.Result.List;
                  let keyName = obj.key ? obj.key : '';
                  if(keyName){
                      this.ApiData.forEach((data, index) => {
                          data.statusName = data[keyName] === 1 ? obj.oneName : obj.zeroName;
                      })
                  }
                  if(data.Data.Result.hasOwnProperty('Page')) {
                      this.apiPage = data.Data.Result.Page;
                  }
              }
              this.tableLoading = false;
          });
      },

      getMemberApiResult(func,obj) {
          this.tableLoading = true;
          func.then(data => {
              if(data.Data.Result.Info.status) {
                  this.ApiData = data.Data.Result.List;
                  let keyName = obj ? obj.key : '';
                  this.ApiData.forEach((data, index) => {
                      data.mergeData = data.mb_name+'('+ data.mb_nick +')';
                      if(obj){
                          data.statusName = data[keyName] === 1 ? obj.oneName : obj.zeroName;
                      }
                  })
                  if(data.Data.Result.hasOwnProperty('Page')) {
                      this.apiPage = data.Data.Result.Page;
                  }
              }
              this.tableLoading = false;
          });
      },
      getCategoryApiResult(func) {
          this.tableLoading = true;
          func.then(data => {
              if(data.Data.Result.Info.status) {
                  this.Categorys = data.Data.Result.List;
              }
              this.tableLoading = false;
          });
      },

    getQaApiResult(func){
        this.tableLoading = true;
        func.then(data => {
            if(data.Data.Result.Info.status) {
                this.ApiData = data.Data.Result.List;
                this.ApiData.forEach((data, index) => {
                    data.qa_status_name = data.isAnswer === 1 ? '답변완료' : '답변대기'
                    let cateWrap = this.Categorys.filter(cate => cate.qc_idx == data.qc_idx)
                    data.qa_category_name = cateWrap.length > 0 ? cateWrap[0].qc_category : data.qa_category;
                    data.qa_writer = `${data.mb_name}(${data.mb_nick})`;
                })
                if(data.Data.Result.hasOwnProperty('Page')) {
                    this.apiPage = data.Data.Result.Page;
                }
            }
            this.tableLoading = false;
        });
    },
    setApiList(List) {
      this.ApiData = List;
      this.tableLoading = false;
    },
    initData() {
      this.ApiData = [];
      this.pageRow = 10;
      this.page = 1;
      this.tableLoading = true;
    },
    tableIndex(index) {
      return this.Listlength - index - (this.page - 1) * this.pageRow;
    },
    cellClick(row, column, cell) { //만약 필요하면 가져가서 커스텀하기

    },
    resetPage() {
      this.page = 1;
      this.choiceRow = [];
    },
    updatePageRow(val) {
      this.resetPage();
      this.pageRow = val
    },
    orderName(orderName) {
      return orderName === 'asc' || orderName === 'ascending' ? 'ascending' : orderName === 'desc' || orderName === 'descending' ? 'descending' : null;
    },

    sortChange({ column, prop, order }) {
      this.page = 1;
      let sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : "";
      this.setSort(prop, sortOrder)
    },

    async arDelete(params) {
      this.choiceRow = params.key;
      let alertTxt = {
          title: '',
          content: '삭제 성공'
      };
      let keyName = params.name;
      let keyType = params.type ? params.type : '';
      await this.choiceRow.forEach(row => {
          let deleteKey = {};
          deleteKey[keyName] = row[keyName];
          if(keyType){
              deleteKey[keyType] = params.typeValue;
          }
          params.func(deleteKey).then( res => res.Data.Result).then(res => {
              if(!res.Info.status) {
                  alertTxt.title = ''
                  alertTxt.content = '삭제 실패'
                  return false;
              }
          });
      });
      await this.createAlert({
          title: alertTxt.title,
          content: alertTxt.content,
          btnText: "확인",
          hide :() => {
              this.getList();
          }
      });
    },

    tableIndexApi(index) {
        return this.apiPage.total - index - (this.page - 1) * 10;
    },

    tableSelectChnage(row) {
        this.choiceRow = row;
    },

    MoveChild(url){
        this.$router.push(url);
    },
    dateReFormDot(date) {
        return date.split(' ')[0].replace(/-/gi, ".");
    },
  },
  computed: {
    ListData() {
      this.List = [];
      if(this.filterFlag) {
        this.List = this.filterData
      } else {
        this.List = this.ApiData
      }
      if(this.List.length > 0) {
        return this.List.slice( (this.page - 1) * this.pageRow, this.page * this.pageRow  )
      } else {
        return this.List
      }
    },
    Listlength() {
      let List = [];
      if(this.filterFlag) {
        List = this.filterData
      } else {
        List = this.ApiData
      }

      return this.apiPage.total;
    }
  }
}